module.exports = __webpack_public_path__ + "img/payBackGround.57206e94.png";